import { jsx as n, jsxs as l } from "@emotion/react/jsx-runtime";
import { useTheme as b } from "@emotion/react";
import { BannerContainer as C, BannerContent as T, BannerParagraph as u, BadgeContainer as D, OverrideIcon as c, OverrideText as t, StyledIconClose as g } from "./Banner.styled.js";
import { Button as x } from "../Button/index.js";
import { Stack as B } from "../Stack/index.js";
import { Text as O } from "../Text/index.js";
import { ThemeMode as L } from "../../types/theme.js";
import { FontAwesomeIconsPartooUsed as r, IconPrefix as o } from "../../types/components/icon.js";
const k = {
  default: [r.faCircleUser, o.SOLID],
  slate: [r.faWandMagicSparkles, o.SOLID],
  warning: [r.faWarning, o.SOLID],
  info: [r.faCircleInfo, o.SOLID],
  danger: [r.faCircleExclamation, o.SOLID]
}, F = ({
  dataTrackId: d,
  children: s,
  icon: f,
  variant: e = "default",
  hideIcon: m = !1,
  withCloseIcon: p = !0,
  onClose: h = () => {
  },
  actionButtonText: i,
  onAction: I = () => {
  },
  badge: a,
  themeMode: y = L.LIGHT
}) => {
  const S = b();
  return /* @__PURE__ */ n(C, { variant: e, themeMode: y, tabIndex: 0, children: /* @__PURE__ */ l(T, { bannerType: e, children: [
    /* @__PURE__ */ l(u, { children: [
      a && /* @__PURE__ */ n(D, { bannerType: e, children: /* @__PURE__ */ n(O, { variant: "bodySBold", color: e === "default" ? S.colors.theme.initial : "white", children: a }) }),
      !m && /* @__PURE__ */ n(c, { iconSize: "16px", icon: f ?? k[e], bannerType: e }),
      " ",
      /* @__PURE__ */ n(t, { variant: "bodyMBold", as: "p", bannerType: e, children: s })
    ] }),
    /* @__PURE__ */ l(B, { direction: "row", alignItems: "center", children: [
      i && i.length > 0 && /* @__PURE__ */ n(x, { size: "small", appearance: "outlined", onClick: I, dataTrackId: d, variant: e === "info" ? "primary" : e, children: /* @__PURE__ */ n(t, { variant: "bodySBold", as: "p", bannerType: e, children: i }) }),
      p && /* @__PURE__ */ n(g, { bannerType: e, onClick: h, children: /* @__PURE__ */ n(c, { icon: [r.faClose], bannerType: e }) })
    ] })
  ] }) });
};
export {
  F as Banner
};
